export const validation = {
  titleMaxChar: 100,
  paragraphMaxChar: 500
}
